module.exports = __webpack_public_path__ + "static/media/stocks-15.fb83712b.jpg";